export const personaAccountPaths = [
    "/persona-file/:id",
    "/persona-file/:id/manage-users",
    "/persona-file/:id/manage-labels",
]